import ProvincesIndex from './ProvincesIndex';

export default ProvincesIndex;
